import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-v',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>V icon</title><path d="M23.474,0.159L17.08,0.775c-0.406,0.039-0.844,0.383-0.978,0.768l-4.092,11.749L7.898,1.542 C7.764,1.158,7.325,0.814,6.92,0.775L0.526,0.159C0.121,0.12-0.096,0.399,0.041,0.783L8.085,23.15 c0.138,0.383,0.581,0.695,0.988,0.695h6.223h0.039c0.073,0,0.134-0.02,0.179-0.055c0.124-0.062,0.231-0.169,0.275-0.292 l0.039-0.108l8.13-22.607C24.096,0.399,23.879,0.12,23.474,0.159z"/></svg>`,
    styles: []
})
export class SimpleIconsVComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#5D87BF';
    @Input() className: string = 'simple-icons-v'
    constructor() {}
    ngOnInit(): void {}
}
